import { Info } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";

import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import { Alert, useTheme } from "@mui/material";

interface AnalyticsIntegrationsAlertProps {
  setOpen: (open: boolean) => void;
}

export const AnalyticsIntegrationsAlert = ({
  setOpen,
}: AnalyticsIntegrationsAlertProps) => {
  const navigate = useNavigate();
  const theme = useTheme();
  return (
    <Alert
      severity={"info"}
      variant={"outlined"}
      onClose={() => setOpen(false)}
      sx={{
        marginTop: "30px",
        borderRadius: "8px",
        display: "flex",
        alignItems: "center",
        paddingY: 0,
        border: `1px solid ${theme.igPrimitives.gray["A400"]}`,
        backgroundColor: "white",
      }}
      icon={<Info size={18} />}
    >
      <IgTypography variant={"h3"} sx={{ fontWeight: 600 }}>
        Analytics Integrations:{" "}
      </IgTypography>
      <IgTypography sx={{ fontWeight: 400 }}>
        {" "}
        Delve deeper with Google Analytics, MS Clarity, Hotjar, and other
        integrations that plug directly into Intelligems.{" "}
      </IgTypography>
      <IgTypography
        onClick={async () => void navigate("/integrations")}
        sx={{
          color: theme.palette.text.interactive.accent.default,
          "&:hover": {
            cursor: "pointer",
          },
        }}
      >
        Try it!
      </IgTypography>
    </Alert>
  );
};
